import { render, staticRenderFns } from "./CourseCategories.vue?vue&type=template&id=58cc3572&scoped=true&"
import script from "./CourseCategories.vue?vue&type=script&lang=js&"
export * from "./CourseCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cc3572",
  null
  
)

export default component.exports